export function initMaterial(){
    const tabs = document.querySelectorAll<HTMLButtonElement>(".tab-item");
    const title = document.querySelector<HTMLElement>(".shop-service-head-title");
    const materials = document.querySelectorAll<HTMLElement>(".material-item");

    if (!tabs.length || !title || !materials.length) return;

    tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
            const selectedId = tab.dataset.id;
            if (!selectedId) return;

            // 1️⃣ Переключаем active
            tabs.forEach((t) => t.classList.remove("active"));
            tab.classList.add("active");

            // 2️⃣ Меняем заголовок
            title.textContent = tab.textContent?.trim() || "";

            // 3️⃣ Фильтрация
            materials.forEach((item) => {
                const itemCategory = item.getAttribute("material-data");

                if (selectedId === "all" || itemCategory === selectedId) {
                    item.style.display = "flex";
                } else {
                    item.style.display = "none";
                }
            });
        });
    });
}